<template>
  <div class="orderCenterList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.salesManagement.inputOrderNumber"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.salesManagement.orderNumber }}：{{ item.OrderNumber }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.enterprise }}：{{ item.CompanyNameSn }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.businessType }}：{{ item.BusinessTypeStr }}
        </div>
        <div class="list-item">
          <div class="list-item-child">
            {{ $t.salesManagement.pNumber }}：{{ item.NumberPackages }}
          </div>
          <div class="list-item-child">
            {{ $t.salesManagement.volume }}：{{ item.Volume }}
          </div>
          <div class="list-item-child">
            {{ $t.salesManagement.weight }}：{{ item.Weight }}
          </div>
        </div>
        <div class="list-item">
          {{ $t.salesManagement.delivery }}：{{ item.DeliveryCountryCity }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.destination }}：{{ item.DestinationCountryCity }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.orderPcState }}：{{ item.OrderPCStateStr }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.createDate }}：{{ item.CreateTime }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.OrderId)"
            >{{ $t.salesManagement.entrustDetail }}</van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoCustomerDetail(item.CustomerId)"
            >{{ $t.salesManagement.customerInfo }}</van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoSop(item)"
          >
            <span v-if="item.SOPId">{{ $t.meta.editButton }} SOP</span>
            <span v-else>{{ $t.salesManagement.addSop }}</span>
          </van-button>

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="deleteEntrustOrder(item.OrderId)"
          >
            {{ $t.meta.delete }}
          </van-button>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.salesManagement.orderState }}</div>
        <van-radio-group v-model="orderPCState" direction="horizontal">
          <van-radio name="0">{{ $t.salesManagement.state1 }}</van-radio>
          <van-radio name="1">{{ $t.salesManagement.state2 }}</van-radio>
          <van-radio name="2">{{ $t.salesManagement.state3 }}</van-radio>
          <van-radio name="3">{{ $t.salesManagement.state4 }}</van-radio>
          <van-radio name="4">{{ $t.salesManagement.state5 }}</van-radio>
          <van-radio name="5">{{ $t.salesManagement.state6 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.businessType }}</div>
        <van-radio-group v-model="businessType" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="selectedCountry.text"
          :label="$t.meta.country"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showOrderCenterListCountry')"
        />

        <van-field
          clickable
          readonly
          :value="selectedCity.text"
          :label="$t.meta.city"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showOrderCenterListCity')"
        />
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showOrderCenterListCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showOrderCenterListCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoCreate">{{
        $t.salesManagement.createButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "orderCenterList",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      orderPCState: null,
      businessType: null,
      selectedCountry: { text: "", value: null },
      selectedCity: { text: "", value: null },
      showFilter: false,
      //选项
      countryList: [],
      cityList: [],
    };
  },
  created() {
    this.getOptions();
  },
  methods: {
    deleteEntrustOrder(id) {
      this.$commonMethod.showLoading();
      var param = {
        OrderId: id,
      };
      this.$api.salesManagement
        .deleteEntrustOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoCreate() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "entrustOrderCreate",
        name: "entrustOrderCreate",
        query: [],
      });
    },
    gotoSop(item) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "commissionCreate",
        name: "commissionCreate",
        query: [
          {
            name: "OrderId",
            value: item.OrderId,
          },
          {
            name: "SOPId",
            value: item.SOPId,
          },
        ],
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "commissionDetail",
        name: "commissionDetail",
        query: [
          {
            name: "OrderId",
            value: id,
          },
        ],
      });
    },
    gotoCustomerDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "basicInfoDetail",
        name: "basicInfoDetail",
        query: [
          {
            name: "CustomerId",
            value: id,
          },
          {
            name: "IsView",
            value: true,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.orderPCState ||
        this.businessType ||
        this.selectedCountry.value ||
        this.selectedCity.value ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.orderPCState = null;
      this.businessType = null;
      this.selectedCountry = { text: "", value: null };
      this.selectedCity = { text: "", value: null };
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCountry(item) {
      this.selectedCountry.text = item.text;
      this.selectedCountry.value = item.value;
    },
    onSelectCity(item) {
      this.selectedCity.text = item.text;
      this.selectedCity.value = item.value;
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        OrderNumber: this.searchText,
        OrderPCState: this.orderPCState,
        BusinessType: this.businessType,
        CountryId: this.selectedCountry.value,
        CityId: this.selectedCity.value,
        CompanyId: this.CompanyId,
      };
      this.$api.salesManagement
        .getOrderProcessingCenterList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([this.getCountryList(), this.getCityList()]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.orderCenterList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        .list-item-child {
          display: inline-block;
          width: 33.33%;
        }
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          margin-bottom: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
